package api


sealed class ResourceOrientation(val mask: Int, val key: String, val label: String) {


    data object UNDEFINED : ResourceOrientation(1, "UNDEFINED", "All")
    data object HORIZONTAL : ResourceOrientation(2, "HORIZONTAL", "Horizontal")
    data object VERTICAL : ResourceOrientation(4, "VERTICAL", "Vertical")

    infix fun ResourceOrientation.and(other: ResourceOrientation): Int = mask + other.mask

    infix fun match(id: Int): Boolean = this.mask and id > 0

    companion object {
        val all by lazy {
            listOf(
                UNDEFINED,
                HORIZONTAL,
                VERTICAL
            )
        }

        operator fun get(type: Int): ResourceOrientation {
            return all.firstOrNull { it match type } ?: UNDEFINED
        }

        operator fun get(key: String): ResourceOrientation {
            return all.firstOrNull { it.key == key.uppercase() } ?: UNDEFINED
        }
    }
}
